import styled from '@emotion/styled/macro';
import { NAVBAR_SECTION_WIDTH } from '../../../../common/constants/navbar-section-widths';
import vars from '../../variables';

export const NavColumn = styled.div`
  margin: 0;
  padding: ${vars.spacingM};
  border-radius: 4px;
  grid-area: ${({ gridAreaIndex }) => `grid-area-${gridAreaIndex}`};
  background: ${({ background }) => background || 'transparent'};

  &:last-of-type {
    margin-bottom: 0;
  }

  &:first-of-type {
    border-radius: 0;
    border-right: 1px solid #2f2f46;
  }

  @media screen and (min-width: ${vars.breakPointTablet}) {
    margin: ${vars.spacingXl} 0 0;
    padding: ${vars.spacingL} ${vars.spacingL} ${vars.spacingM};

    &:last-of-type {
      margin-bottom: ${vars.spacingXl};
    }
  }

  @media screen and (min-width: ${vars.breakPointSmallDesktop}) {
    margin: ${vars.spacingXl} 0 ${vars.spacingXxl};
    padding: ${vars.spacingL} ${vars.spacingL} ${vars.spacingM};

    &:last-of-type {
      margin-bottom: ${vars.spacingXl};
    }
  }
`;

export const NavSectionHeading = styled.div`
  font-size: 1.4rem;
  font-weight: ${vars.fontWeightMedium};
  color: ${vars.borderMidGrey};
  text-transform: uppercase;
  margin: ${vars.spacingL} 0 ${vars.spacingXs};
  padding-bottom: ${vars.spacingXs};

  &:first-of-type {
    margin-top: 0;
  }

  & + div {
    margin-bottom: ${vars.spacingM};
  }

  @media screen and (min-width: ${vars.breakPointTablet}) {
    font-weight: ${vars.fontWeightBold};
    font-size: 1.1rem;
  }
`;

export const NavItems = styled.div`
  display: block;

  ${({ isLastColumn }) => {
    if (isLastColumn) {
      return `
        display:block;
        @media screen and (min-width: ${vars.breakPointTablet}) {
          display:flex;        
          flex-wrap: wrap;
          flex-direction: row;
        }
        @media screen and (min-width: ${vars.breakPointSmallDesktop}) {         
          flex-direction: column;
        }
      `;
    }
  }}

  ${({ columnWidth }) => {
    if (columnWidth === NAVBAR_SECTION_WIDTH.HALF) {
      return `        
        @media screen and (min-width: ${vars.breakPointTablet}) {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          grid-auto-rows: auto;
          grid-column-gap: 1.6rem;
          grid-row-gap: 0px;
        }
    `;
    }
  }}
`;
